import Head from 'next/head';
import type { ReactElement } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BookOpen } from 'lucide-react';

export default function Books(): ReactElement {
  return (
    <>
      <Head>
        <title>KEM Discovery Books</title>
        <meta name="description" content="Explore KEM Discovery books available on Amazon." />
      </Head>

      <section className="">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">Books</h1>
        <p className="text-muted-foreground mb-10">A curated list of KEM books available on Amazon.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="flex flex-col">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BookOpen className="size-6" />
                KEM Book 1
              </CardTitle>
              <CardDescription>Emotions and Motivation in the Workplace: A Practical Guide</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex items-end">
              <Button asChild className="w-full">
                <a
                  href="https://www.amazon.com/EMOTIONS-MOTIVATION-WORKPLACE-PRACTICAL-GUIDE/dp/B0DWKZW7S3/ref=tmm_hrd_swatch_0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Amazon
                </a>
              </Button>
            </CardContent>
          </Card>

          <Card className="flex flex-col">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BookOpen className="size-6" />
                KEM Book 2
              </CardTitle>
              <CardDescription>Emotions, Relationships, AND KEMs</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex items-end">
              <Button asChild className="w-full">
                <a
                  href="https://www.amazon.com/dp/B0FFZ24SDS/ref=tmm_hrd_swatch_0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Amazon
                </a>
              </Button>
            </CardContent>
          </Card>

          <Card className="flex flex-col">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BookOpen className="size-6" />
                KEM Book 3
              </CardTitle>
              <CardDescription>Discover Who You Are: and Unlock Your Greater Potential</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex items-end">
              <Button asChild className="w-full">
                <a
                  href="https://www.amazon.com/dp/B0FKHCY2CL?ref=cm_sw_r_ffobk_cp_ud_dp_0QH0AZY9VG0XCR3KGJYC&ref_=cm_sw_r_ffobk_cp_ud_dp_0QH0AZY9VG0XCR3KGJYC&social_share=cm_sw_r_ffobk_cp_ud_dp_0QH0AZY9VG0XCR3KGJYC&bestFormat=true&csmig=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Amazon
                </a>
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>
    </>
  );
}


